<script>

export default {
    props: {
        branch: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            data: {},
        };
    },
    watch: {
        branch() {
            var vm = this;

            vm.load();
        }
    },
    mounted() {
        var vm = this;

        vm.load();
    },
    methods: {
        load() {
            var vm = this;

            vm.create();
        },
        create() {
            var vm = this;

            vm.data = Object.assign({}, vm.branch);
        },
        async submit() {
            var vm = this;
            this.$loading.on('branch_detail_config_submit');

            try {
                var postData = vm._createPostData(vm.data);
                var resp = await this.$api.Branch.create(postData);

                var data = resp.data;

                vm.$emit('onUpdate');

                this.$flash.success(data.message);
            } catch (err) {
                this.$flash.error(err.response.data.message);
            }
            this.$loading.off('branch_detail_config_submit');
        },
        _createPostData(data) {

            return data;
        },
        async destroy() {
            var vm = this;

            vm.$alert.confirm(vm.$t('basic.alert.delete'), async function (result) {
                if (result.isConfirmed) {
                    var id = vm.$route.params.id;

                    var params = {
                        id: id,
                        is_permanent: 0
                    };

                    try {
                        vm.$loading.on('branch_detail_config_delete');

                        var resp = await vm.$api.Branch.delete(params);

                        vm.$emit('onDelete');

                        vm.$flash.success(resp.data.message);
                    } catch (error) {
                        vm.$flash.error(error.response.data.message);
                    }

                    vm.$loading.off('branch_detail_config_delete');
                }
            });
        },
        fetchStore: async function (params) {
            const resp = await this.$api.Store.all(params)

            const data = resp.data.data

            const list = data.map(row => ({
                id: row.id,
                text: row.text,
                model: row,
            }))

            const meta = resp.data.meta

            return {
                options: list,
                more: meta.current_page < meta.last_page
            }
        },
    }
};
</script>

<template>
    <BRow class="justify-content-center">
        <BCol>
            <b-form @submit="submit()">
                <BCard no-body>
                    <BCardBody>
                        <loading :loading="$loading.get('branch_detail_create')" variant="dark" type="block">
                            <BRow>
                                <BCol class="mb-3" lg="12" v-if="$ac.hasAccess('branch_full_access')">
                                    <label class="form-label" for="product-title-input">{{
                                        $t('branch.label.ref_no')
                                        }}</label>
                                    <input type="text" class="form-control" v-model="data.ref_no"
                                        id="product-title-input" :placeholder="$t('branch.placeholder.ref_no')"
                                        :disabled="$loading.get('branch_detail_create')" />
                                </BCol>
                                <BCol class="mb-3" lg="12" v-if="$ac.hasAccess('branch_full_access')">
                                    <label for="choices-publish-status-input" class="form-label">{{
                                        $t('branch.label.store')
                                        }}</label>
                                    <dynamic-select v-model="data.store_id"
                                        :placeholder="$t('branch.placeholder.store')" :loadOptions="fetchStore" />
                                </BCol>
                                <BCol class="mb-3" lg="12">
                                    <label class="form-label" for="product-title-input">{{
                                        $t('branch.label.name')
                                        }}</label>
                                    <input type="text" class="form-control" v-model="data.name" id="product-title-input"
                                        :placeholder="$t('branch.placeholder.name')"
                                        :disabled="$loading.get('branch_detail_create')" />
                                </BCol>
                                <BCol class="mb-3" lg="12">
                                    <div>
                                        <label for="exampleFormControlTextarea5" class="form-label">{{
                                            $t('branch.label.address') }}</label>
                                        <textarea class="form-control" id="exampleFormControlTextarea5" rows="3"
                                            v-model="data.address" :placeholder="$t('branch.placeholder.address')"
                                            :disabled="$loading.get('branch_detail_create')"></textarea>
                                    </div>
                                </BCol>
                                <BCol lg="12">
                                    <div class="hstack gap-2 justify-content-between">
                                        <BButton type="button" variant="danger" class="w-sm" @click="destroy(data.id)"
                                            v-if="$ac.hasAccess('branch_full_access') || ($ac.hasAccess('branch_delete') && $ac.hasAccessStore(data.store_id))"
                                            :disabled="$loading.get('branch_detail_config_delete')">
                                            <loading :loading="$loading.get('branch_detail_config_delete')"
                                                variant="light" type="button">
                                                <i class="mdi mdi-delete-outline"></i>
                                                {{ $t('basic.btn.delete') }}
                                                {{ $t('menu.sub_header.branch') }}
                                            </loading>
                                        </BButton>
                                        <div class="d-flex gap-2"
                                            v-if="$ac.hasAccess('branch_full_access') || ($ac.hasAccess('branch_create') && $ac.hasAccessStore(data.store_id))">
                                            <BButton type="submit" variant="success" class="w-sm"
                                                :disabled="$loading.get('branch_detail_config_submit')">
                                                <loading :loading="$loading.get('branch_detail_config_submit')"
                                                    variant="light" type="button">
                                                    <i class="mdi mdi-floppy me-1"></i>
                                                    {{ $t('basic.btn.save') }}
                                                </loading>
                                            </BButton>
                                        </div>
                                    </div>
                                </BCol>
                            </BRow>
                        </loading>
                    </BCardBody>
                </BCard>
            </b-form>
        </BCol>
    </BRow>
</template>